export const ABBREVIATION_MAP: Record<string, string> = {
  PR: 'Puerto Rico',
  USVI: 'Virgin Islands',
  'U.S Virgin Islands': 'Virgin Islands',
  'U.S. Virgin Islands': 'Virgin Islands',
  'US Virgin Islands': 'Virgin Islands',
  'U.S. Virgin Islands U.S. Virgin Islands': 'Virgin Islands',
  'Washington DC': 'District of Columbia',
};
export const TYPO_MAP: Record<string, string> = {
  'Porto Rico': 'Puerto Rico',
  'Armed Forcees Europe': 'Armed Forces Europe',
  'Armed Forcees Pacific': 'Armed Forces Pacific',
  'Armed Forces America': 'Armed Forces Americas',
  'Marshal Islands': 'Marshall Islands',
};
